// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"faf22376","389":"ebfa51a7","397":"3dae804f","525":"e8430921"}[chunkId] + ".chunk.js";
};